import React from "react";
import { NavLink } from "react-router-dom";
import TwoPhoneSection from "./TwoPhoneSection";
import ThreePhoneCommonMainAction from "./ThreePhoneCommonMainAction";
import HowItWork from "./HowItWork";
import TeeRating from "./TeeRating";
import Usp from "./Usp";

const Home = () => {
  // Define reusable button layout for sections
  const renderButtons = (primaryLink, secondaryLink, primaryText, secondaryText) => (
    <div className="home__section__buttons">
      <NavLink to={primaryLink} target="_self" className="btn-color">
        {primaryText}
      </NavLink>
      <NavLink to={secondaryLink} target="_self" className="btn-not-color">
        {secondaryText}
      </NavLink>
    </div>
  );

  return (
    <div className="home">
      {/* Hero Section */}
      <ThreePhoneCommonMainAction
        heading={<span>REVOLUTIONARY <br /> GOLFING APP</span>}
        show_subHeading
        imgSrc={require("../../assets/images/pages/home/section_1/home_hero_section.svg").default}
        showSubHeading={true}
      />
      
      {/* Section 1: Resolve Slow Play */}
      <TwoPhoneSection
        heading="RESOLVE SLOW PLAY WITH TIMELY GOLF"
        showBtn={true}
        className=""
        btnLayout={renderButtons("/club-detail", "/contact", "SIGN UP", "CONTACT US")}
      />
      
      {/* Section 2: Digital Score Logging */}
      <TwoPhoneSection
        heading="DIGITAL SCORE LOGGING AND GAME HISTORY"
        showBtn={true}
        className="reverse"
        btnLayout={renderButtons("/club-detail", "/contact", "SIGN UP", "CONTACT US")}
      />
      
      {/* Additional Sections */}
      <HowItWork />
      <TeeRating />
      <Usp />
    </div>
  );
};

export default Home;
